export default __webpack_public_path__ + "media/images/react_icons/share_book-ef10623ac96b40616e65bf23c3c0f844.svg";